import { List } from 'immutable';

import { DiscoveryKeys } from './constants';

export function getIsFetching(state) {
  return state.discovery.getIn([DiscoveryKeys.BROWSE, DiscoveryKeys.IS_FETCHING], false);
}

export function getFetchingOffsets(state) {
  return state.discovery.getIn([DiscoveryKeys.BROWSE, DiscoveryKeys.FETCHING_OFFSETS], List());
}

export function getBrowseTopLevelModules(state) {
  return state.discovery.getIn([DiscoveryKeys.BROWSE, DiscoveryKeys.TOP_LEVEL_SECTIONS], List());
}

export function getBrowseDeepLevelDirectories(state) {
  return state.discovery.getIn([DiscoveryKeys.BROWSE, DiscoveryKeys.DEEP_LEVEL_SECTIONS], List());
}

export function getBrowseDeepLevelDirectoryByUrl(state, webUrl) {
  const deepLevelDirectories = getBrowseDeepLevelDirectories(state);
  const webUrlTrimmed = webUrl && webUrl.replace(/\/$/, '');
  return deepLevelDirectories.find(directory => {
    return directory.webUrl === webUrlTrimmed;
  });
}

export function getBrowseCurrentWebUrl(state) {
  return state.discovery.getIn([DiscoveryKeys.BROWSE, DiscoveryKeys.WEB_URL]);
}

export function getBrowseDeepLevelDirectoryByRequestId(state, requestId) {
  return getBrowseDeepLevelDirectories(state).find(directory => directory.requestId === requestId);
}

export function getIsInvalidUrl(state) {
  return state.discovery.getIn([DiscoveryKeys.BROWSE, DiscoveryKeys.IS_INVALID_URL]);
}
